import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
  standalone: true,
  imports: [],
  selector: 'app-register-header',
  template: `
    <div
      class="mx-auto size-24 flex items-center justify-center rounded-full bg-gray-300 text-black"
    >
      <svg
        class="size-16 text-gray-50"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
        ></path>
      </svg>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {}
